<template>
    <!-- 调整异常状态，地址挂靠管理和续费管理都有这个弹窗 -->
    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
        :cancel-button-props="{ size: 'middle' }" title="确定调整异常状态?" placement="right" @openChange="openChange"
        @confirm="change_anomaly_status()">
        <template #description>
            <a-form style="width: 700px; margin-top: 30px" v-bind="formLayout">
                <a-form-item label="调整状态为" style="width: 800px" required>
                    <a-radio-group v-model:value="state.exception_flag2">
                        <a-radio :value="1" :style="radioStyle">正常状态</a-radio>
                        <a-radio :value="2" :style="radioStyle">待申报异常【代理商待确认①】</a-radio>
                        <a-radio :value="3" :style="radioStyle"
                            v-if="props.customerData.exception_flag != 1">待申报异常【代理商已确认，公司待确认②】</a-radio>
                        <a-radio :value="4" :style="radioStyle"
                            v-if="props.customerData.exception_flag != 1">待申报异常【代理商、公司已确认，准备提交资料③】</a-radio>
                        <a-radio :value="5" :style="radioStyle">已申报异常【已交资料，待确认是否地址异常】</a-radio>
                        <a-radio :value="6" :style="radioStyle">人工已确认地址已异常</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="代理商确认申报异常时间剩余" style="width: 800px" v-if="state.exception_flag2 == 2" required>
                    <a-input v-model:value="state.endtime" placeholder="请输入" style="width: 320px" suffix="小时">
                    </a-input>
                </a-form-item>
                <a-form-item label="调整状态理由" style="width: 800px" v-if="state.exception_flag2 == 1" required>
                    <a-input v-model:value="state.desc" placeholder="请输入理由" style="width: 320px"> </a-input>
                </a-form-item>
                <a-form-item label="调整状态理由" style="width: 800px" v-else>
                    <a-input v-model:value="state.desc" placeholder="请输入理由" style="width: 320px"> </a-input>
                </a-form-item>
                <a-form-item label="备注"> 从异常状态变为正常状态需要输入理由！ </a-form-item>
            </a-form>
        </template>
        <slot>
            <!-- 默认内容，当父组件没有提供插槽内容时显示 -->
            <p>调整异常状态</p>
        </slot>
    </a-popconfirm>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const props = defineProps({
    customerData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['change'])
interface IState {
    desc: string
    exception_flag2: number | null
    endtime: number
}
const state = reactive<IState>({
    desc: '',
    exception_flag2: null,
    endtime: 7 * 24
})
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
//关闭时候清空数据
const openChange = (e) => {
    if (!e) {
        state.desc = ''
        state.exception_flag2 = null
        state.endtime = 7 * 24
    }
}
//改变地址异常主体的异常状态
const change_anomaly_status = () => {
    if (state.exception_flag2 == null) {
        message.warn('请选择调整状态')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (state.exception_flag2 == 1 && !state.desc) {
        message.warn('请输入变更为正常状态的理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    } else if (state.exception_flag2 == 2 && !state.endtime) {
        message.warn('请输入代理商确认时间')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let new_flag = state.exception_flag2
    let new_endtime = state.endtime
    let requestParam = {
        url: '/admin/v1/change_anomaly_status',
        method: 'post',
        data: { customer_id: props.customerData.id, desc: state.desc, exception_flag: state.exception_flag2, endtime: state.endtime }
    }
    baseService(requestParam)
        .then((res: any) => {
            emit('change', new_flag, new_endtime)
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('列入异常失败，请联系管理员')
            }
        })
    return new Promise((resolve, reject) => {
        resolve(true)
    })
}
const radioStyle = reactive({
    display: 'flex',
    height: '30px',
    lineHeight: '30px',
});
</script>
